import React, { useContext } from "react";
import { Outlet } from "react-router-dom";
import { AppContext } from "../context";
import { getCurrentUser } from "../auth/service";
import Cart from "../store/components/Cart";
import AuthModal from "../store/components/AuthModal";

const Layout = () => {
  const {
    isCartOpen,
    toggleCart,
    isAuthModalOpen,
    closeAuthModal,
    setCurrentUser,
  } = useContext(AppContext);

  const handleAuthSuccess = () => {
    setCurrentUser?.(getCurrentUser());
    closeAuthModal?.();
    // For Store auth gating (e.g., price visibility), a reload ensures
    // the underlying page re-queries and re-renders with authenticated state.
    window.location.reload();
  };

  return (
    <div>
      <Outlet />
      {typeof isCartOpen === "boolean" && typeof toggleCart === "function" && (
        <Cart isOpen={isCartOpen} toggle={toggleCart} />
      )}
      {typeof isAuthModalOpen === "boolean" && (
        <AuthModal
          isOpen={isAuthModalOpen}
          toggle={closeAuthModal}
          onSuccess={handleAuthSuccess}
          forceRegister
        />
      )}
    </div>
  );
};

export default Layout;
